import { Check, Image as ImageIcon, Monitor } from 'lucide-react';
import { photoUrl } from '../api';
import type { LibraryPhoto } from '../types';

type Props = {
  photo: LibraryPhoto;
  selected?: boolean;
  selectable?: boolean;
  onSelect?: () => void;
  onOpen?: () => void;
};

export function PhotoCard({ photo, selected, selectable, onSelect, onOpen }: Props) {
  const action = selectable ? onSelect : onOpen;
  return (
    <button
      type="button"
      className={`photo-card ${selected ? 'selected' : ''}`}
      onClick={action}
      aria-pressed={selectable ? selected : undefined}
    >
      <span className="photo-thumb">
        <img src={photoUrl(photo)} alt="" loading="lazy" />
        {selected && <span className="selected-mark"><Check size={16} /></span>}
      </span>
      <span className="photo-copy">
        <strong>{photo.name}</strong>
        <span><Monitor size={14} /> {photo.screens.length} {photo.screens.length === 1 ? 'screen' : 'screens'}</span>
      </span>
      {!photo.screens.length && <span className="unmapped"><ImageIcon size={13} /> Needs mapping</span>}
    </button>
  );
}
